module.exports = __webpack_public_path__ + "img/1.004e0dc3.png";